import { Controller } from "@hotwired/stimulus"

// A simple form validation controller that disables the submit button until a
// field is filled out.
// Connects to data-controller="form-validation"
export default class extends Controller {
  static targets = ["inputField", "submitButton"]

  connect() {
    this.validate()
  }

  validate() {
    this.submitButtonTarget.disabled = this.inputFieldTarget.value.trim() === ''
  }
}